module.exports = __webpack_public_path__ + "img/safari-flying-icon.75f205ff.svg";